import axios from "axios";
import { GetResponse, mapApiResponse } from "api/toBeSigned/mappers";

const getToBeSigned = async (): Promise<GetResponse> => {
  const response = await axios.get(`/api/to-be-signed`);
  return mapApiResponse(response.data);
};

export default getToBeSigned;
